import InfiniteScroll from "react-infinite-scroll-component";

import { IUser } from "services/types";
import { CreatorTile } from "./CreatorTile";
import { Columnizer } from "components/blocks/Columnizer";

import "./CreatorsFeed.scss";

/* eslint-disable no-magic-numbers */

const COLUMNS = [500];

/* eslint-enable no-magic-numbers */

export const CreatorsFeed = (props: {
  users: IUser[];
  hasMore: boolean;
  fetchMore: () => void;
}): JSX.Element => {
  return (
    <InfiniteScroll
      dataLength={props.users.length}
      hasMore={props.hasMore}
      next={props.fetchMore}
      loader={<></>}
    >
      <Columnizer sizes={COLUMNS}>
        <div className="creatorsFeed">
          {props.users.map((user: IUser, index: number) => (
            <CreatorTile
              key={index}
              user={user}
            />
          ))}
        </div>
      </Columnizer>
    </InfiniteScroll>
  );
};
